import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import SellerOnlyRouteMixin from 'sh-www/mixins/seller-only-route-mixin';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { POSTING__APP_SELLER_INCLUDES } from 'sh-www/constants/routes/posting';
import { APPLICATION } from 'sh-www/models/application';

class PostingAppRoute extends Route.extend(SellerOnlyRouteMixin) {
  @service router;

  /** @inheritDoc */
  queryParams = {
    tab: {
      replace: true,
      refreshModel: false,
    },
  };

  @action
  error() {
    this.router.transitionTo(EMBER_ROUTE_NAMES.PAGE_NOT_FOUND);
  }

  model({ applicationId }) {
    return this.controllerFor('posting.app').silentlyLoadApplication(
      applicationId,
      POSTING__APP_SELLER_INCLUDES
    );
  }

  redirect(model) {
    if (model.status >= APPLICATION.STATUS.ACTIVE && !model.direct) {
      this.router.transitionTo(EMBER_ROUTE_NAMES.PROJECT__DETAILS, model.id);
    }
  }

  setupController(controller, application, transition) {
    super.setupController(...arguments);

    if (transition.data.errors) {
      controller.set('incomingErrors', transition.data.errors);
    }

    controller.set('application', application);
    controller.loadThreadData.perform(application);
    controller.loadPaymentData.perform(application);

    const initialTab = transition.to.queryParams.tab
    if (initialTab) {
      controller.set('currentSubNavState', initialTab);
    }
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadThreadData.cancelAll({ resetState: true });
      controller.loadPaymentData.cancelAll({ resetState: true });
      controller.resetProperties();
    }
  }

  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/posting/:assignId/app/:applicationId');
  }

  deactivate() {
    super.deactivate(...arguments);
    this.controllerFor('posting.app').handleProfileOverlayClose();
  }
}

export default PostingAppRoute;
